import React from "react";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const ResearchProjects: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section className="py-16 ">
            <div className="max-w-7xl mx-auto px-6">

                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 mb-6">
                    <div>
                        <p className="text-sm text-[#7ede56] mb-2">{t("research_projects_label")}</p>
                        <h2 className="text-3xl md:text-4xl font-semibold text-[#002f37] max-w-xl leading-tight">
                            {t("research_projects_heading")}
                        </h2>
                    </div>

                    <Link
                        to="/projects"
                        className="self-start lg:self-center flex items-center gap-2 bg-[#7ede56] text-white px-5 py-3 rounded-lg text-sm font-medium hover:bg-[#002F3F] transition"
                    >
                        {t("research_projects_cta")}
                        <span className="bg-white text-[#000000] rounded-full w-7 h-7 flex items-center justify-center">
                            →
                        </span>
                    </Link>
                </div>

                {/* Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

                    {/* Big Card */}
                    <div className="lg:col-span-2 relative rounded-2xl overflow-hidden">
                        <img
                            src="/smart.webp"
                            alt="Corporate Solar"
                            className="w-full h-[300px] object-cover  rounded-2xl"
                        />


                    </div>

                    {/* Right Stats */}
                    <div className="bg-white rounded-2xl p-6 flex flex-col justify-between border-1 border-black">
                        <div>
                            <h4 className="text-3xl font-semibold text-[#002f37] mb-2">
                                {t("research_projects_stat_title")}
                            </h4>
                        </div>



                        <div className="mt-3">
                            <p className="text-sm font-medium text-[#002f37] mb-2">
                                {t("research_projects_stat_paragraph_1")}

                            </p>
                            <p className="text-sm text-[#002f37]">
                                {t("research_projects_stat_paragraph_2")}

                            </p>



                        </div>
                    </div>

                    {/* Bottom Cards */}
                    <div className="rounded-2xl overflow-hidden bg-white">
                        <img
                            src="/left project.webp"
                            className="w-full h-70 object-cover"
                        />

                    </div>

                    <div className="rounded-2xl overflow-hidden bg-[#002f37] text-white p-6 flex flex-col ">
                        <h4 className="text-3xl font-semibold mb-2 ">
                            {t("research_projects_card_collab_title")}
                        </h4>
                        <p className="text-sm">
                            {t("research_projects_card_collab_body_1")}
                        </p>
                        <p className="text-sm mt-2">
                            {t("research_projects_card_collab_body_2")}
                        </p>
                    </div>

                    <div className="rounded-2xl overflow-hidden bg-white">
                        <img
                            src="/polycarbonate10.webp"
                            className="w-full h-70 object-fit"
                        />

                    </div>

                </div>
            </div>
        </section>
    );
};

export default ResearchProjects;
